
import poke from '../Assets/poke.png';
import planta from '../Assets/proyect/planta.png';
import green from '../Assets/proyect/green.png';
import travel from '../Assets/proyect/travel.png';
import learn from '../Assets/proyect/learn.png';
import rick from '../Assets/proyect/rick-app.png';
import pizza from '../Assets/proyect/pizza-app.png';
import giff from '../Assets/proyect/gif-app.png';
import card from '../Assets/proyect/card-app.png';
import ui from '../Assets/proyect/desing-app.png';
import red from '../Assets/proyect/red.png';
import mountain from '../Assets/proyect/mountain.png';
import '../pages/Portfolio.css';
import left from "../Assets/iconSkills/left.png"
import right from "../Assets/iconSkills/right.png"

import React, { useState } from 'react';
import { Link } from 'react-router-dom'; 

export const CardPortfolio = () => {
  const cards = [
    { id: 1, title: 'Pokedex', image: poke, link: '/pokedex' },
    { id: 3, title: 'GreenNotes', image: green, link: '/green-notes' },
    { id: 4, title: 'Travel memory', image: travel, link: '/memory-match' },
    { id: 5, title: 'Learning List', image: learn, link: '/learning-list' },
    { id: 6, title: 'GreenWay', image: planta, link: '/greenway' },
    { id: 7, title: 'Card Validation', image: card, link: '/card-validation' },
    { id: 8, title: 'Pizza App', image: pizza, link: '/pizza-app' },
    { id: 9, title: 'Desing Canvas', image: ui, link: '/desing-canvas' },
    { id: 10, title: 'Gif App', image: giff, link: '/gif-app' },
    { id: 11, title: 'Rick and morty', image: rick, link: '/rick-and-morty' },
  ];

  const [startIndex, setStartIndex] = useState(0);

  const nextCards = () => {
    setStartIndex((prevIndex) =>
      prevIndex + 3 < cards.length ? prevIndex + 3 : 0
    );
  };

  const prevCards = () => {
    setStartIndex((prevIndex) =>
      prevIndex - 4 >= 0 ? prevIndex - 4 : cards.length - 4
    );
  };

  return (

 
    <div className='card-list'> <img onClick={nextCards} src={left} alt="Back" className="left-button" />
      {cards.slice(startIndex, startIndex + 3).map((card) => (
        <div className='card-portfolio' key={card.id}>
          <div>
            <img src={card.image} alt='icon' className='card-icon' />
          </div>
          <div className='card-content'>
            <h2 className='card-title'>{card.title}</h2>
            <Link to={card.link}>
              <button className='card-button'>See more</button>
            </Link>
          </div>
        </div>
      ))}
      <div className='slider-buttons'>
       <img onClick={prevCards} src={right} alt="Back" className="rigth-button" />


      </div>
    </div>
  );
};


/* import React from 'react';

export const CardPortfolio = () => {
  return (
    <div className='card-list'>
    <div className="card-portfolio" >
      <div>
        <img src={poke} alt="icon" className="card-icon" />
      </div>
      <div className="card-content">
        <h2 className="card-title">Pokedex</h2>
         <Link to="/pokedex"><button className="card-button">See more</button></Link>
      </div>
    </div>
     <div className="card-portfolio" >
      <div>
        <img src={plata} alt="icon" className="card-icon" />
      </div>
      <div className="card-content">
        <h2 className="card-title">GreenWay</h2>
         <Link to="/greenway"><button className="card-button">See more</button></Link>
      </div>
    </div>
    <div className="card-portfolio" >
      <div>
        <img src={green} alt="icon" className="card-icon" />
      </div>
      <div className="card-content">
        <h2 className="card-title">GreenNotes</h2>
         <Link to="/green-notes"><button className="card-button">See more</button></Link>
      </div>
    </div>
    <div className="card-portfolio" >
      <div>
        <img src={travel} alt="icon" className="card-icon" />
      </div>
      <div className="card-content">
        <h2 className="card-title">Travel memory</h2>
         <Link to="/memory-match"><button className="card-button">See more</button></Link>
      </div>
    </div>
    <div className="card-portfolio" >
      <div>
        <img src={learn} alt="icon" className="card-icon" />
      </div>
      <div className="card-content">
        <h2 className="card-title">Learning List</h2>
         <Link to="/learning-list"><button className="card-button">See more</button></Link>
      </div>
    </div>
    <div className="card-portfolio" >
      <div>
        <img src={red} alt="icon" className="card-icon" />
      </div>
      <div className="card-content">
        <h2 className="card-title">Transmuta</h2>
         <Link to="/transmuta"><button className="card-button">See more</button></Link>
      </div>
    </div>
    </div>
  );
};
 */